module.exports = __webpack_public_path__ + "img/media (15).052c6385.png";